import { Horizontal, MomentDatePicker, MomentTimePicker, Texto } from '@gravitate-js/excalibrr'
import { DatePicker, Form, Radio, Switch, TimePicker } from 'antd'
import type { FormInstance } from 'antd/es/form/Form'
import moment from 'moment'
import React from 'react'

import type { OutageForm } from '../types'

type EventScheduleInputsProps = {
  form: FormInstance<OutageForm>
}

export function EventScheduleInputs({ form }: EventScheduleInputsProps) {
  function defaultEndDate(selectedDefault: 'eod' | 'eow' | 'custom') {
    const startDate = form.getFieldValue(['schedule_local', 'start_date'])
    switch (selectedDefault) {
      case 'eod':
        form.setFieldsValue({ schedule_local: { end_date: moment(startDate), end_time: moment().endOf('day') } })
        break
      case 'eow':
        form.setFieldsValue({
          schedule_local: { end_date: moment(startDate).endOf('week'), end_time: moment().endOf('day') },
        })
        break
      default:
        form.setFieldsValue({ schedule_local: { end_date: null, end_time: null } })
    }
  }

  return (
    <div>
      <Horizontal>
        <Form.Item
          label='Start'
          name={['schedule_local', 'start_date']}
          rules={[{ required: true, message: 'Select Start Date' }]}
        >
          <MomentDatePicker
            format='MM/DD/yyyy'
            disabledDate={(current) => current && current < moment().startOf('day')}
          />
        </Form.Item>
        <Form.Item
          name={['schedule_local', 'start_time']}
          rules={[{ required: true, message: 'Select Start Time' }]}
          style={{ marginTop: '1.7rem' }}
          className='ml-2'
        >
          <MomentTimePicker format='hh:mm a' />
        </Form.Item>
      </Horizontal>
      <Form.Item label='End' required style={{ marginBottom: '0' }}>
        <Radio.Group
          onChange={(e) => defaultEndDate(e.target.value)}
          defaultValue='custom'
          style={{ marginBottom: '8px' }}
        >
          <Radio.Button value='custom'>Custom</Radio.Button>
          <Radio.Button value='eod'>EOD</Radio.Button>
          <Radio.Button value='eow'>EOW</Radio.Button>
        </Radio.Group>
        <Form.Item noStyle dependencies={[['schedule_local', 'isForever']]}>
          {({ getFieldValue }) => {
            const isForever = getFieldValue(['schedule_local', 'isForever'])
            return (
              <Horizontal>
                <Form.Item
                  name={['schedule_local', 'end_date']}
                  rules={[{ required: !isForever, message: 'Select End Date' }]}
                >
                  <MomentDatePicker
                    format='MM/DD/yyyy'
                    disabled={isForever}
                    disabledDate={(current) => current && current < moment().startOf('day')}
                  />
                </Form.Item>
                <Form.Item
                  name={['schedule_local', 'end_time']}
                  rules={[{ required: !isForever, message: 'Select End Time' }]}
                  className='ml-2'
                >
                  <MomentTimePicker format='hh:mm a' disabled={isForever} />
                </Form.Item>
                <Texto className='mr-1 ml-4 mt-2'>Forever</Texto>
                <Form.Item name={['schedule_local', 'isForever']} valuePropName='checked'>
                  <Switch />
                </Form.Item>
              </Horizontal>
            )
          }}
        </Form.Item>
      </Form.Item>
    </div>
  )
}
